(() => {
  const PRODUCT_CACHE = new Map();
  const SYNC_DELAYS = [0, 80, 180, 350, 650, 1100];

  function money(cents) {
    const currency = window.Shopify?.currency?.active || 'AUD';
    const locale = currency === 'AUD' ? 'en-AU' : (document.documentElement.lang || 'en');
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function productUrl(picker) {
    const raw = String(picker?.dataset?.productUrl || window.location.pathname || '').split('?')[0];
    if (!raw) return '';
    return raw.endsWith('.js') ? raw : `${raw.replace(/\/$/, '')}.js`;
  }

  async function getProduct(picker) {
    const url = productUrl(picker);
    if (!url) return null;
    if (!PRODUCT_CACHE.has(url)) {
      PRODUCT_CACHE.set(
        url,
        fetch(url, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product JSON ${response.status}`);
            return response.json();
          })
          .catch((error) => {
            PRODUCT_CACHE.delete(url);
            console.warn('[BBT exact variant sync] product JSON failed', error);
            return null;
          })
      );
    }
    return PRODUCT_CACHE.get(url);
  }

  function selectedValues(picker, product) {
    const valuesByName = new Map();

    picker.querySelectorAll('select').forEach((select) => {
      const option = select.selectedOptions?.[0];
      const name = option?.dataset?.optionName || select.name?.match(/^options\[(.*)\]$/)?.[1] || '';
      if (name && option) valuesByName.set(name, option.value);
    });

    picker.querySelectorAll('fieldset input:checked').forEach((input) => {
      const name = input.dataset.optionName || '';
      if (name) valuesByName.set(name, input.value);
    });

    return (product?.options || []).map((optionName, index) => {
      if (valuesByName.has(optionName)) return valuesByName.get(optionName);
      const unique = [...new Set((product?.variants || []).map((variant) => variant.options?.[index]).filter(Boolean))];
      return unique.length === 1 ? unique[0] : '';
    });
  }

  function exactVariantFromEvent(event, product, picker) {
    const target = event?.target;
    const selected = target instanceof HTMLSelectElement ? target.selectedOptions?.[0] : target;
    const selectedId = selected?.dataset?.variantId;
    if (selectedId) {
      const byId = product.variants?.find((variant) => String(variant.id) === String(selectedId));
      if (byId) {
        const current = selectedValues(picker, product);
        if (byId.options?.every((value, index) => !current[index] || current[index] === value)) return byId;
      }
    }

    const current = selectedValues(picker, product);
    if (!current.length || current.some((value) => !value)) return null;
    return product.variants?.find((variant) =>
      variant.options?.length === current.length && variant.options.every((value, index) => value === current[index])
    ) || null;
  }

  function renderVariant(picker, variant) {
    if (!variant) return false;
    const section = picker.closest('.shopify-section') || document;
    const productId = String(picker.dataset.productId || '');
    const variantId = String(variant.id || '');
    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compare_at_price || 0);

    const renderPrice = () => {
      const primarySelector = productId
        ? `product-price[data-product-id="${CSS.escape(productId)}"] [ref="priceContainer"]`
        : 'product-price [ref="priceContainer"]';
      const containers = [
        ...section.querySelectorAll(primarySelector),
        ...section.querySelectorAll('.sticky-add-to-cart__price [ref="priceContainer"]'),
      ];
      [...new Set(containers)].forEach((container) => {
        if (compareAt > price) {
          container.innerHTML =
            `<span class="price-item__group price-item--regular compare-at-price"><span class="visually-hidden">Regular price&nbsp;</span>${money(compareAt)}</span>` +
            `<span class="price-item__group price"><span class="visually-hidden">Sale price&nbsp;</span>${money(price)}</span>`;
        } else {
          container.innerHTML = `<span class="price">${money(price)}</span>`;
        }
        container.dataset.bbtExactVariantPriceId = variantId;
      });

      const stickyVariant = section.querySelector('.sticky-add-to-cart__variant');
      if (stickyVariant && variant.title) stickyVariant.textContent = variant.title;
    };

    const stampVariantId = () => {
      section.querySelectorAll('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dataset.bbtExactVariantId = variantId;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };

    SYNC_DELAYS.forEach((delay) => {
      window.setTimeout(renderPrice, delay);
      window.setTimeout(stampVariantId, delay);
    });
    renderPrice();
    stampVariantId();
    return true;
  }

  async function sync(event, picker) {
    if (!(picker instanceof HTMLElement)) return;
    const product = await getProduct(picker);
    if (!product?.variants?.length) return;
    const variant = exactVariantFromEvent(event, product, picker);
    if (!variant) return;
    renderVariant(picker, variant);
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const picker = target.closest('variant-picker');
    if (!picker) return;
    sync(event, picker);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-picker').forEach((picker) => sync(null, picker));
  });
})();
